import { render, staticRenderFns } from "./AppNotificationBanner.vue?vue&type=template&id=641a3e24&scoped=true"
import script from "./AppNotificationBanner.vue?vue&type=script&lang=js"
export * from "./AppNotificationBanner.vue?vue&type=script&lang=js"
import style0 from "./AppNotificationBanner.vue?vue&type=style&index=0&id=641a3e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a3e24",
  null
  
)

export default component.exports